import axios from 'axios';
import { useState } from 'react';
import JSZip from 'jszip';
import { getServiceOne } from '../../services/servicesService';
import { formatDateV4, formatarData } from '../../utils/date';
import { linkPDFV2 } from '../../utils/savePDF';
import { useToast } from '../../pages/components/Toats';
import { getFileBase64 } from '../../services/files';
import { getInvoicePDFFile } from '../../services/invoices';
import { postConvertPdfV3 } from '../../services/ConvertPDFService';
import { getfileUrl } from '../../services/uploadService';
import useSize from '../../hooks/useSize';

/** Gera o PDF de uma O.S a partir do template vinculado (HTML ou DOCX) ou do template padrão. */
export function useOrderServicePdf() {
    const { toggleToast } = useToast();
    const [loadingPDF, setLoadingPDF] = useState<boolean>(false)
    const {width : largura} = useSize()

    const getImage = async (key: string) => {
        try {
          const url = await getFileBase64(key)
          return url.base64
    
        } catch (error) {
          console.log(error)
          return ""
        }
    }

    const replaceValues = async (dados: any, html: string) => {
        let novoHtml = html;
        const imageCompany = dados 
        && dados.unitBranch 
        && dados.unitBranch.company 
        && dados.unitBranch.company.image 
        ? await getImage(dados.unitBranch.company.image)
        : "https://i.postimg.cc/kXzT1qjT/sua-logo-aqui.pngs";

        let dados_OS = {
            imageCompany: imageCompany ? `data:image/jpeg;base64,${imageCompany}` : "https://i.postimg.cc/kXzT1qjT/sua-logo-aqui.pngs",
            corporateName: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.corporateName ? dados.unitBranch.company.corporateName : "",
            cnpj: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.cnpj ? dados.unitBranch.company.cnpj : "",
            street: dados && dados.unitBranch && dados.unitBranch.street ? dados.unitBranch.street : "",
            district: dados && dados.unitBranch && dados.unitBranch.district ? dados.unitBranch.district : "",
            number: dados && dados.unitBranch && dados.unitBranch.number ? dados.unitBranch.number : "",
            telephone: dados && dados.unitBranch && dados.unitBranch.telephone ? dados.unitBranch.telephone : "",
            emailCompany: dados && dados.unitBranch && dados.unitBranch.emailCompany ? dados.unitBranch.emailCompany : "",
            number_order_service: dados && dados.number_order_service ? dados.number_order_service : "",
            dateCreate: dados && dados.created_at ? formatarData(dados.created_at) : "",
            nameResponsible: dados && dados.client && dados.client.nameResponsible ? dados.client.nameResponsible : "",
            cpfResponsible: dados && dados.client && dados.client.cpfResponsible ? dados.client.cpfResponsible : "",
            telephoneClient: dados && dados.client && dados.client.telephone ? dados.client.telephone : "0000-000",
            cellphoneClient: dados && dados.client && dados.client.cellphone ? dados.client.cellphone : "(00) 0 0000-0000",
            emailClient: dados && dados.client && dados.client.email ? dados.client.email : "",
            namePlant: dados && dados.plant && dados.plant.name ? dados.plant.name : "",
            addressPlant: dados && dados.plant && dados.plant.address ? dados.plant.address : "",
            titulo: dados && dados.title ? dados.title : "",
            status: dados && dados.status ? dados.status : "",
            description: dados && dados.description ? dados.description : "",
            addressService: dados && dados.address ? dados.address : "",
            companyName: dados && dados.unitBranch && dados.unitBranch.companyName ? dados.unitBranch.companyName : "",
            
            // value_sub_final: dados && dados.value_sub_final ? dados.value_sub_final : "0",
            // value_discont: dados && dados.value_discont ? dados.value_discont : "0",
            // value_final: dados && dados.value_final ? dados.value_final : "0",

            dateEnd: dados && dados.dateEnd ? formatDateV4(dados.dateEnd) : "",
            dateInit: dados && dados.dateInit ? formatDateV4(dados.dateInit) : "",

            value_sub_final: dados && dados.value_sub_final && Number(dados.value_sub_final) > 0 
            ? dados.value_sub_final.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
            : '0,00',

            value_discont: dados && dados.value_discont && Number(dados.value_discont) > 0 
            ? dados.value_discont.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
            : '0,00',

            value_final: dados && dados.value_final && Number(dados.value_final) > 0 
            ? dados.value_final.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
            : '0,00',
            
            nameCollaborator : dados && dados.collaborators && dados.collaborators.length > 0 && dados.collaborators[0].name ? dados.collaborators[0].name : "",
            telefoneCollaborator: dados && dados.collaborators && dados.collaborators.length > 0 && dados.collaborators[0].telephone ? dados.collaborators[0].telephone : "",
            emailCollaborator : dados && dados.collaborators && dados.collaborators.length > 0 && dados.collaborators[0].email ? dados.collaborators[0].email : "",

            itensServices: dados && dados.itensServices ?     
            dados.itensServices.map((item: any) => {
                const my_item = {
                    service: item 
                    ? item.tipo === "SERVICO" && item.typeService && item.typeService.description ? item.typeService.description 
                    : item.tipo === "PRODUTO" && item.product && (item.product.name || item.product.description) ? (item.product.name || item.product.description) : ""
                    : "",
    
                    description: item && item.description ? item.description : "",
                    
                    //value: item && item.value ? item.value : "",
                    value: item && item.value && Number(item.value) > 0 
                    ? item.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                    : '0,00',
                    
                    amount: item && item.amount ? item.amount : "",
                    
                    //sub_value: item && item.sub_value ? item.sub_value : "",
    
                    sub_value: item && item.sub_value && Number(item.sub_value) > 0 
                    ? item.sub_value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                    : '0,00',
                }
                // const my_item = {
                //     service: item && item.typeService && item.typeService.description ?  item.typeService.description : "",
                //     description: item && item.description ? item.description : "",
                //     value: item && item.value ? item.value : "",
                //     amount: item && item.amount ? item.amount : "",
                //     sub_value: item && item.sub_value ? item.sub_value : "",
                // }
                return my_item
            }) : []
    
        }
    
        Object.keys(dados_OS).forEach(chave => {
            if(chave === 'itensServices'){
                const servicesHtml = dados_OS[chave].map((service: any) => {
                    const tds = Object.keys(service).map(key => {
                      
                        if(key === 'sub_value' || key === 'value'){
                            return `<td>R$ ${service[key]}</td>`
                        }else{
                            return `<td>${service[key]}</td>`
                        }
    
                      //return `<td>${report[key]}</td>`;
                    }).join('');
                    return `<tr>${tds}</tr>`;
                  }).join('');
        
                  novoHtml = novoHtml.replace(
                    `{{${chave}}}`,
                    `<table style="width: 100%;">
                        <thead>
                            <tr>
                                <th class="bg-body">Serviço/Produto</th>
                                <th class="bg-body">Descrição</th>
                                <th class="bg-body">Valor Unit.</th>
                                <th class="bg-body">Qtd</th>
                                <th class="bg-body">Total</th>
                            </tr>
                        </thead>
                        <tbody id="table_services" style="color: rgb(31, 31, 31);">${servicesHtml}</tbody>
                      </table>` 
                    // `<tbody id="table_services">${servicesHtml}</tbody>`
                  );
            }else{
                const marcador = new RegExp(`{{${chave}}}`, 'g');
                novoHtml = novoHtml.replace(marcador, dados_OS[chave] );
            }
        });
        return novoHtml;
    }

    const fetchHtmlAsString = async () => {
        try {
          const response = await axios.get('/media/HTMLs/template_OS.html', { responseType: 'text' });
          return response.data;
        } catch (error) {
          console.error('Error fetching HTML file:', error);
          return null;
        }
    };

    const processDocx = async (fileOrUrl: any, placeholders: any) => {
        try {
          let file;
      
          if (fileOrUrl && typeof fileOrUrl === "string") {
            
    
            const response: any = await getInvoicePDFFile(fileOrUrl);
              if (response) {
                const blob = response.data;
                file = new File([blob], "original-document.docx", { type: blob.type });
              }
          }
          
          if(file){
            const arrayBuffer = await file.arrayBuffer();
            const zip: any = await JSZip.loadAsync(arrayBuffer);
        
            const documentXml = await zip.file("word/document.xml").async("string");
            let updatedXml = documentXml;
        
            for (const [placeholder, value] of Object.entries(placeholders)) {
              const regex = new RegExp(`{{${placeholder}}}`, "g");
              updatedXml = updatedXml.replace(regex, value);
            }
      
            zip.file("word/document.xml", updatedXml);
            const updatedDocx = await zip.generateAsync({ type: "blob" });
        
            const pdfFormData = new FormData();
            pdfFormData.append("file", updatedDocx, "processed-document.docx");
        
            const response = await postConvertPdfV3(pdfFormData);
        
            const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        
            const uploadFormData = new FormData();
            uploadFormData.append("file", pdfBlob, "final-document.pdf");
        
            const uploadResponse = await getfileUrl(uploadFormData);
    
            if (uploadResponse && uploadResponse.url) {
              let pdfUrl = uploadResponse.url;
        
              if(largura && largura < 1000){
                const url = new URL(pdfUrl);
                url.searchParams.append('open_external_app', 'true');
                pdfUrl = url.toString();
              }
              window.open(pdfUrl, '_blank', 'noopener,noreferrer');
            } else {
              console.error('Erro ao obter a URL do arquivo após o upload.');
            }
            console.log("Documento processado e convertido para PDF com sucesso!");
          }
        } catch (error) {
          console.error("Erro ao processar o documento:", error);
        }
      };

    const substituteValues = async (file: any, dados: any) => {
        if (file) {
          try {
            let placeholderData = {
              corporateName: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.corporateName ? dados.unitBranch.company.corporateName : "",
              cnpj: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.cnpj ? dados.unitBranch.company.cnpj : "",
              street: dados && dados.unitBranch && dados.unitBranch.street ? dados.unitBranch.street : "",
              district: dados && dados.unitBranch && dados.unitBranch.district ? dados.unitBranch.district : "",
              number: dados && dados.unitBranch && dados.unitBranch.number ? dados.unitBranch.number : "",
              telephone: dados && dados.unitBranch && dados.unitBranch.telephone ? dados.unitBranch.telephone : "",
              emailCompany: dados && dados.unitBranch && dados.unitBranch.emailCompany ? dados.unitBranch.emailCompany : "",
              number_order_service: dados && dados.number_order_service ? dados.number_order_service : "",
              dateCreate: dados && dados.created_at ? formatarData(dados.created_at) : "",
              nameResponsible: dados && dados.client && dados.client.nameResponsible ? dados.client.nameResponsible : "",
              cpfResponsible: dados && dados.client && dados.client.cpfResponsible ? dados.client.cpfResponsible : "",
              telephoneClient: dados && dados.client && dados.client.telephone ? dados.client.telephone : "0000-000",
              cellphoneClient: dados && dados.client && dados.client.cellphone ? dados.client.cellphone : "(00) 0 0000-0000",
              emailClient: dados && dados.client && dados.client.email ? dados.client.email : "",
              namePlant: dados && dados.plant && dados.plant.name ? dados.plant.name : "",
              addressPlant: dados && dados.plant && dados.plant.address ? dados.plant.address : "",
              titulo: dados && dados.title ? dados.title : "",
              status: dados && dados.status ? dados.status : "",
              description: dados && dados.description ? dados.description : "",
              addressService: dados && dados.address ? dados.address : "",
              companyName: dados && dados.unitBranch && dados.unitBranch.companyName ? dados.unitBranch.companyName : "",
              value_sub_final: dados && dados.value_sub_final ? dados.value_sub_final : "0",
              value_discont: dados && dados.value_discont ? dados.value_discont : "0",
              value_final: dados && dados.value_final ? dados.value_final : "0",
              ...(
                  dados &&
                  dados &&
                  dados.itensProposal
                      ? dados.itensProposal.reduce((acc, item, index) => {
                          const idx = index + 1;
                          return {
                              ...acc,
                              [`itemDescription${idx}`]: item && item.description ? item.description : "",
                              [`itemService${idx}`]: item && item.tipo === "SERVICO" && item.typeService && item.typeService.description ? item.typeService.description : "",
                              [`itemProduct${idx}`]: item && item.tipo === "PRODUTO" && item.product && (item.product.name || item.product.description) ? (item.product.name || item.product.description) : "",
                              [`itemValue${idx}`]: item && item.value ? item.value : "",
                              [`itemAmount${idx}`]: item && item.amount ? item.amount : "",
                              [`itemSubValue${idx}`]: item && item.sub_value ? item.sub_value : "",
                          };
                      }, {})
                      : {}
              )
            };
    
            await processDocx(file, placeholderData);
          } catch (error) {
            console.error("Erro ao processar o documento:", error);
          }
        }
      }

    const normalizeServiceDates = (service: any) => {
        if (!service) return service
        const normalized = { ...service }
        if (normalized.dateInit) {
          const date = new Date(normalized.dateInit)
          date.setHours(date.getHours() + 3)
          normalized.dateInit = date.toISOString()
        }
        if (normalized.dateEnd) {
          const date = new Date(normalized.dateEnd)
          date.setHours(date.getHours() + 3)
          normalized.dateEnd = date.toISOString()
        }
        return normalized
    }

    const resolveServiceForPdf = async (order: any) => {
        let serviceData = order

        if (!serviceData?.templatesOS?.length && serviceData?.id) {
          try {
            const fullService = await getServiceOne(String(serviceData.id))
            serviceData = normalizeServiceDates(fullService)
          } catch (error) {
            console.log(error)
          }
        }

        return normalizeServiceDates(serviceData)
    }

    const previewPDF = async (order: any) => {
        try {
            setLoadingPDF(true)

            const serviceData = await resolveServiceForPdf(order)

            const myTemplate =
              serviceData?.templatesOS?.length > 0
                ? serviceData.templatesOS[0]
                : null

            if (myTemplate?.typeDoc === 'html') {
              const templateHTML =
                myTemplate.textHTML || (await fetchHtmlAsString())

              const template_modificad = await replaceValues(
                serviceData,
                templateHTML || '<h1>Template não encontrado!</h1>'
              )
              await linkPDFV2(
                template_modificad || '<h1>Template não encontrado!</h1>'
              )
              return
            }

            if (myTemplate?.typeDoc === 'docx') {
              await substituteValues(myTemplate.linkDocx, serviceData)
              return
            }

            const defaultTemplate = await fetchHtmlAsString()
            if (!defaultTemplate) {
              toggleToast('Template não encontrado para gerar o PDF.', 'error')
              return
            }

            const template_modificad = await replaceValues(
              serviceData,
              defaultTemplate
            )
            await linkPDFV2(template_modificad)
        } catch (error) {
            console.log(error)
            toggleToast('Erro ao gerar o PDF da O.S.', 'error')
        } finally {
            setLoadingPDF(false)
        }
    }

    return { previewPDF, loadingPDF }
}
